export const INTERACTIVE_CARD_HOVER_BORDER_COLOR = '#D5D5D5'
export const INTERACTIVE_CARD_HOVER_BOX_SHADOW =
  '0 8px 24px rgba(0, 28, 87, 0.12)'

export const interactiveCardHoverStyles = theme => ({
  transition: theme.transitions.create(['box-shadow', 'border-color'], {
    duration: 200,
  }),
  '&:hover': {
    borderColor: INTERACTIVE_CARD_HOVER_BORDER_COLOR,
    boxShadow: INTERACTIVE_CARD_HOVER_BOX_SHADOW,
  },
})

export const interactiveCardFocusStyles = {
  '&:focus-visible': {
    outline: '2px solid #0053FF',
    outlineOffset: 2,
  },
}

export const interactiveCardInteractionStyles = {
  userSelect: 'none',
  WebkitUserSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  '& .MuiCardActionArea-focusHighlight': {
    display: 'none',
  },
  '& img': {
    pointerEvents: 'none',
    userDrag: 'none',
    WebkitUserDrag: 'none',
  },
}

export const interactiveCardLinkResetStyles = {
  textDecoration: 'none',
  color: 'inherit',
  '&:hover, &:focus, &:active, &:visited': {
    textDecoration: 'none',
    color: 'inherit',
  },
}

export const interactiveActivateControlResetStyles = {
  appearance: 'none',
  WebkitAppearance: 'none',
  display: 'block',
  width: '100%',
  margin: 0,
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  font: 'inherit',
  color: 'inherit',
  textAlign: 'left',
  cursor: 'pointer',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  '&::-moz-focus-inner': {
    border: 0,
    padding: 0,
  },
  '&:focus:not(:focus-visible)': {
    outline: 'none',
  },
  ...interactiveCardFocusStyles,
}
